import HttpRequest from "../request";
import type { } from "./types";
import { TranslatePageApi, TranslateEditApi } from "../api";
import type { Response } from "../request";

export default {
    getTranslateTextAreaApi(params: any): Promise<Response<any>> {
        return HttpRequest.post(TranslateEditApi.getTranslateTextAreaApi, params)
    },
    getTranslateEditTransApi(params: any): Promise<Response<any>> {
        return HttpRequest.post(TranslateEditApi.getTranslateEditTransApi, params)
    },
    getAwsUploadFileUrl(params: any): Promise<Response<any>> {
        return HttpRequest.get(TranslatePageApi.getAwsUploadFileUrl, params)
    },
    getAwsUploadFileUrlApi(params: any): Promise<Response<any>> {
        return HttpRequest.post(TranslatePageApi.getAwsUploadFileUrlApi, params)
    },
    getAwsUploadFileApi(params: any): Promise<Response<any>> {
        return HttpRequest.post(TranslatePageApi.getAwsUploadFileApi, params)
    },
    async uploadJsonData(jsonData: any, url: string, fileName: string): Promise<any>  {
        const blob = new Blob([JSON.stringify(jsonData)], { type: 'application/json' });
        const formData = new FormData();
        formData.append('file', blob, fileName);

        try {
            const response = await fetch(url, {
            method: 'put',
            body: jsonData,
            });
            if(response.status == 200 ) return true;

        } catch (error) {
            console.error('Error uploading JSON data:', error);
            return false;
        }
    },
    getForwordPythonApi(params: any): Promise<Response<any>> {
        return HttpRequest.post(TranslatePageApi.getForwordPythonApi, params)
    },
    rectangleUploadJsonData(params: any): Promise<Response<any>> {
        return HttpRequest.post(TranslatePageApi.rectangleUploadJsonData, params)
    },
    retransUploadJsonData(params: any): Promise<Response<any>> {
        return HttpRequest.post(TranslatePageApi.retransUploadJsonData, params)
    },
    getIncrChoiceWordsStat(params: any): Promise<Response<any>> {
        return HttpRequest.get(TranslateEditApi.getIncrChoiceWordsStatApi, params)
    },
    getIncrOnlineEditStat(params: any): Promise<Response<any>> {
        return HttpRequest.get(TranslateEditApi.getIncrOnlineEditStatApi, params)
    }
}
